import React from "react";
import "../style/BasicForexPage.css";

const BasicForexPage = () => {
  return (
    <div className="basic-container">
      <header className="basic-header">
        <h1>What is Forex?</h1>
        <p className="basic-date">Colle Learn - August 10, 2023</p>
      </header>
      
      <section className="basic-section basic-hero">
      <div className="basic-img">
          <img src="/images/basicbg.png" alt="Trading Platform" />
          </div>
        {/* <div className="basic-image-placeholder">Image Placeholder</div> */}
        <h2>What is Forex Trading & How Does It Work?</h2>
      </section>

      <section className="basic-content">
        <h3>What is forex?</h3>
        <p>Quite simply, it’s the <b>global financial market that allows one to trade currencies.</b>

        <br/><br/>If you think one currency will be stronger versus the other, and you end up correct, then you can make a profit.

        <br/><br/>Once upon a time, before a global pandemic happened, people could actually get on airplanes and travel internationally.

        <br/><br/>If you’ve ever traveled to another country, you usually had to find a currency exchange booth at the airport, and then exchange the money you have in your wallet into the currency of the country you are visiting.</p>
        {/* <div className="basic-image-placeholder">Image Placeholder</div> */}
        <div className="basic-img1">
          <img src="/images/basic0.png" alt="Trading Platform" />
          </div>

          <p>
                You go up to the counter and notice a screen displaying different exchange rates for different currencies.<br/><br/>

                An <b>exchange rate</b> is the relative price of two currencies from two different countries.<br/><br/>

                You find “Japanese yen” and think to yourself, “WOW! My one dollar is worth 100 yen?! And I have ten dollars! I’m going to be rich!!!”<br/><br/>

                When you do this, you’ve essentially participated in the forex market!<br/><br/>

                You’ve <b>exchanged one currency for another.</b><br/><br/>

                Or in forex trading terms, assuming you’re an American visiting Japan, you’ve sold dollars and bought yen.<br/><br/>


                Before you fly back home, you stop by the currency exchange booth to exchange the yen that you miraculously have remaining (Tokyo is expensive!) and notice the exchange rates have changed.<br/><br/>

                <b>It’s these changes in the exchange rates that allow you to make money in the foreign exchange market.</b></p>
      </section>




      <div className="basic-text-img">
        <h1>What is forex?</h1>
        <p>The foreign exchange market, which is usually known as “forex” or “FX,” is the largest financial market in the world.

            <br/><br/>The FX market is a global, decentralized market where the world’s currencies change hands.

            <br/><br/>Due to the wide range of market participants, including central banks, financial institutions, corporations, hedge funds, and individual traders, exchange rates change by the second so the market is constantly in flux.

            <br/><br/>Only a tiny percentage of currency transactions happen in the “real economy” involving international trade and tourism like the airport example above.

            <br/><br/>Instead, most of the currency transactions that occur in the global foreign exchange market are bought (and sold) for speculative reasons.

            <br/><br/>Currency traders (also known as currency speculators) buy currencies hoping that they will be able to sell them at a higher price in the future.

            <br/><br/>Compared to the “measly” $200 billion per day volume of the New York Stock Exchange (NYSE), the foreign exchange market looks absolutely ginormous with its $7.5 TRILLION a day trade volume.

            <br/><br/>That’s trillion with a “t”.

            <br/><br/>Let’s take a moment to put this into perspective using monsters…

            <br/><br/>The largest stock market in the world, the New York Stock Exchange (NYSE), trades a volume of about $20 billion each day. If we used a monster to represent the NYSE, it would look like this…</p>

            <div className="basic-img1">
          <img src="/images/basic1.png" alt="Trading Platform" />
          </div>
          <p>Looks intimidating. Looks like it works out. Some may even find it sexy.You hear about the NYSE in the news every day… on CNBC… on Bloomberg…on BBC… heck, you even probably hear about it at your local gym. “The NYSE is up today, blah, blah”.

                <br/><br/>When people talk about the “market”, they usually mean the stock market. So the NYSE sounds big, it’s loud and likes to make a lot of noise.

                <br/><br/>But if you actually compare it to the forex market, it would look like this…</p>
                <br/><br/><br/><br/>
                <div className="basic-img1">
          <img src="/images/basic2.png" alt="Trading Platform" />
          </div>

          <p>Oooh, the NYSE looks so puny compared to the forex market! It doesn’t stand a chance!

          <br/><br/>Makes you wonder if the “S” in NYSE stands for “Stock” or for “Scrawny”?

          <br/><br/>The cryptocurrency market is even punier.

          <br/><br/>Check out the graph of the average daily trading volume for the forex market, New York Stock Exchange, Tokyo Stock Exchange, and London Stock Exchange:</p>
          <br/><br/>      
          <div className="basic-img11">
          <img src="/images/basic3.png" alt="Trading Platform" />
          </div>

          <p>The currency market is over 200 times BIGGER! It is HUGE!

          <br/><br/>But hold your horses, there’s a catch!

          <br/><br/>That huge $7.5 trillion number covers the entire global foreign exchange market, BUT the “spot” market, which is the part of the currency market that’s relevant to most forex traders is smaller at $2 trillion per day.And then, if you just want to count the daily trading volume from retail traders (that’s us), it’s even smaller.

          <br/><br/>It is very difficult to determine the exact size of the retail segment of the FX market, but it’s estimated to be around 3-5% of overall daily FX trading volumes, or around $200-300 billion (probably less).

          <br/><br/>So you see, the forex market is definitely huge, but not as huge as the others would like you to believe.

          <br/><br/>Don’t believe the “forex is a $7.5 trillion market” hype! The huge number sounds impressive, but a bit misleading. We don’t like to exaggerate. We just keepin’ it real.</p>
          <br/><br/>
          <div className="basic-img1">
          <img src="/images/basic4.png" alt="Trading Platform" />
          </div>
          <br/>
          <p>Aside from its size, the market also rarely closes! It’s open virtually round the clock.

          <br/><br/>The forex market is open 24 hours a day and 5 days a week, only closing down during the weekend. (What a bunch of slackers!)

          <br/><br/>So unlike the stock or bond markets, the forex market does NOT close at the end of each business day.

          <br/><br/>Instead, trading just shifts to different financial centers around the world.</p>
          <br/><br/>
          <div className="basic-img1">
          <img src="/images/basic5.gif" alt="Trading Platform" />
          </div>
          <br/><br/>
          <p>The day starts when traders wake up in Auckland/Wellington, then moves to Sydney, Singapore, Hong Kong, Tokyo, Frankfurt, London, and finally, New York, before trading starts all over again in New Zealand!</p>
          <br/><hr/><br/><br/>
          <div id="basic-oslo1"className="oslo-cards">
        <div  className="oslo-card">
          <img
            src="/images/trad.jpg"
            alt="Best intraday trading strategies"
            className="oslo-card-image"
          />
          {/* <p className="oslo-learn"> EXTREDE LEARN • 5 YEARS AGO</p> */}
          <h3 className="oslo-title">Best trading strategies and techniques</h3>
          <p>A trading strategy is a set of rules and guidelines used by traders to make informed decisions about buying, selling, or holding financial instruments such as stocks, currencies, or commodities. It is a systematic approach that helps traders identify and capitalise on trading opportunities based on their analysis of market conditions.</p>
        </div>
        <br/><br/>

        <div className="oslo-card">
          <img
            src="/images/liveTrad.jpg"
            alt="Trading Principles"
            className="oslo-card-image"
          />
          {/* <p className="oslo-learn"> EXTREDE LEARN • 5 YEARS AGO</p> */}
          <h3 className="oslo-title">Trading Principles</h3>
          <p>As a forex trader, your main goal is to take advantage of market opportunities by buying and selling major currency pairs. But forex trading is no walk in the park. While it’s one of the most popular ways to invest, it also requires plenty of study and research. </p>
        </div>
        </div>
          </div>
      
    </div>
  );
};

export default BasicForexPage;